<template>
  <Grid gaf="column" justify-content="space-between" align-items="center" class="opaque-header q-pl-xl q-pr-lg q-py-sm">
    <div class="text-subtitle-2 text-secondary-2">
      {{ isVendor ? 'Vendors' : 'Publishers' }} list view
      <HelpPageBtn :page="__guide[isVendor ? 'vendorPage' : 'publisherPage']" />
    </div>

    <Grid gaf="column" gap="var(--r-space-md)" align-items="center">
      <ExportBtn :loading="exportLoading" @click="$emit('export')" />

      <RBtn size="small" type="tertiary" @click="$emit('create-new-provider')">
        create new {{ isVendor ? 'vendor' : 'publisher' }}
      </RBtn>

      <ShowHideCols :ag-grid="agGrid" />
    </Grid>
  </Grid>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
// Components
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'
import ExportBtn from '@/reusable/ExportBtn'

export default {
  components: {
    ShowHideCols,
    HelpPageBtn,
    ExportBtn
  },

  props: {
    isVendor: Boolean,
    agGrid: Object
  },

  computed: {
    ...mapState('lv-providers', ['exportLoading'])
  }
}
</script>
